export default __webpack_public_path__ + "static/media/upa-sport-5-text-to-path.9dac4ceb.svg";